/**
 * Subscribe.js
 */
$j(document).ready(function () {

//console.log('ready');
    //on tabbar click, load page content and swap page        
    $j('.marketo-form-embed.loaded').ready(function(e){

        // var $parent_li = $(this).parent(); //set parent li dom el
//console.log('loaded');
        setTimeout(function () {
            var email = $j('#postdata').html();
//console.log('looked');
//console.log(email);

//console.log($j('.marketo-form-embed.loaded form.mktoForm.loaded input#Email'));
//console.log($j('.marketo-form-embed.loaded form.mktoForm.loaded input#Email').val());

            if (email) {
//console.log('found');
//console.log($j('input#Email').val());
                $j('.marketo-form-embed.loaded form.mktoForm.loaded input#Email').val(email);
                $j('#postdata').remove();
//console.log($j('input#Email').val());
//console.log('replaced');
            }
//console.log('done');
        }, 1000);
    });
//console.log('set');

});
